import { useGetGroup } from '@vlabs/api/artemy/client';
import { VideoOnIcon } from '@vlabs/icons';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import type { LinkProps } from '@vlabs/uikit/components/controls/link/Link';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './GoToStreamGroupLink.module.sass';
import type { GoToStreamGroupProps } from './types';

type GoToStreamGroupLinkProps = GoToStreamGroupProps & LinkProps & WithDataTestid;

const displayName = 'GoToStreamGroupLink';
const testid = buildTestid(displayName);

function GoToStreamGroupLink({
  groupId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToStreamGroupLinkProps): JSX.Element {
  const { data: group } = useGetGroup(groupId);
  return (
    <div className={st.GoToStreamGroup}>
      <VideoOnIcon className={st.VideoIcon} />
      <Link
        kind="secondary"
        to={generatePath(routes.streamGroups.view, { groupId })}
        {...testid(dataTestId)}
        {...props}
      >
        {group?.group_name ?? groupId}
      </Link>
    </div>
  );
}

GoToStreamGroupLink.displayName = displayName;

export { GoToStreamGroupLink };
